module.exports = __webpack_public_path__ + "7c6c5c4d8d0938fc0aa73a2a6aa38923.pdf";